import { formatEnter } from '../utils'

const EixY = ({ x, y, payload }) => {
	if (payload.value !== 0) {
		return (
			<text x={x} y={y} dy={-6} fill='#888' textAnchor='start' className='e6'>
				{formatEnter(payload.value)}€
			</text>
		)
	}
	return null
}
export default EixY
